/**
 * Page wrapper para o ZTNA Wizard 4-step (route: /admin/ztna/onboard).
 *
 * Permission check + feature flag check:
 *   - sem permission `ztna:onboard:provision` -> Navigate /
 *   - sem flag `ztna_wizard_enabled` -> Navigate /admin/ztna + toast
 *
 * Componente real (state + autosave + submit) eh WizardContainer.
 */
import { useEffect } from 'react'
import { Container } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { Navigate } from 'react-router-dom'
import { WizardContainer } from '@/components/ZtnaAdmin/Wizard/WizardContainer'
import { useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useCan } from '@/store/auth'

export default function ZtnaWizard() {
  const can = useCan()
  const wizardEnabled = useFeatureFlag('ztna_wizard_enabled')

  useEffect(() => {
    if (can('ztna:onboard', 'provision') && !wizardEnabled) {
      notifications.show({
        title: 'Wizard ZTNA',
        message: 'Wizard não habilitado neste ambiente (ZTNA_WIZARD_ENABLED=false).',
        color: 'gray',
      })
    }
  }, [can, wizardEnabled])

  if (!can('ztna:onboard', 'provision')) {
    return <Navigate to="/" replace />
  }

  if (!wizardEnabled) {
    return <Navigate to="/admin/ztna" replace />
  }

  return (
    <Container size="xl" py="md">
      <WizardContainer />
    </Container>
  )
}
